// src/constants/rooms.ts

export default interface Room {
  id: string;
  name: string;
  left: string;
  top: string;
  width: string;
  height: string;
  roomNumber: string;
  zIndex?: string;
  style?: object;
  clipPath?: string;
  borderRadius?: string;
  transform?: string;
  section?: string;
}

export const ROOMS_WAREHOUSE: Room[] = [
  {
    id: "cd2fa866-7bbb-4eb2-b95d-2b674165e20f",
    name: "Помещение склада 1",
    left: "560px",
    top: "180px",
    width: "98px",
    height: "240px",
    roomNumber: "1",
    section: "Склад",
  },
  {
    id: "445f979b-5581-444b-9a84-072473c1f2aa",
    name: "Помещение склада 2",
    left: "825px",
    top: "142px",
    width: "174px",
    height: "275px",
    roomNumber: "2",
    section: "Склад",
  },
];
export const ROOMS_THEATER: Room[] = [
  {
    id: "0e62d7df-f095-408d-aa39-971ae04f726f",
    name: "Коридор",
    left: "1047px",
    top: "355px",
    width: "13px",
    height: "75px",
    roomNumber: "2.1",
    section: "Служебная",
  },

  {
    id: "0e62d7df-f095-408d-aa39-971ae04f726f",
    name: "Коридор",
    left: "951px",
    top: "430px",
    width: "52px",
    height: "20px",
    roomNumber: "2.1",
    section: "Служебная",
  },

  {
    id: "353fe49d-008a-47cc-8a12-33cebca6b2d2",
    name: "Кухня",
    left: "1059px",
    top: "355px",
    width: "34px",
    height: "56px",
    roomNumber: "2.2",
    section: "Служебная",
  },

  {
    id: "a0e6c9cd-31ba-44c1-bb88-9630a2b5c182",
    name: "Репетиционный зал",
    left: "951px",
    top: "355px",
    width: "97px",
    height: "75px",
    roomNumber: "2.3",
    section: "Служебная",
  },
  {
    id: "5b428404-d194-4794-97ae-7b2b34738c9b",
    name: "Костюмерная",
    left: "1059px",
    top: "410px",
    width: "34px",
    height: "20px",
    roomNumber: "2.4",
    section: "Служебная",
  },

  {
    id: "885bbc53-0bb0-477d-8dcb-0db76ac994fa",
    name: "Санузел",
    left: "951px",
    top: "465px",
    width: "32px",
    height: "50px",
    roomNumber: "2.5",
    section: "Служебная",
  },
  {
    id: "4e0e176d-bd70-4c39-985e-29ba96ea0483",
    name: "Кабинет",
    left: "1058px",
    top: "469px",
    width: "17px",
    height: "13px",
    roomNumber: "2.6",
    zIndex: "10",
    section: "Служебная",
  },

  {
    id: "ac21cb5b-1b79-49cd-815d-2611bc52205e",
    name: "Кабинет",
    left: "982px",
    top: "484px",
    width: "31px",
    height: "31px",
    roomNumber: "2.7",
    zIndex: "100",
    section: "Служебная",
  },
  {
    id: "6c3eab38-e284-4eef-a815-79dedabdf0db",
    name: "Офис",
    left: "982px",
    top: "450px",
    width: "66px",
    height: "65px",
    roomNumber: "2.8",
    section: "Служебная",
  },

  {
    id: "4ee5487d-ad80-4384-9604-027c7c9bbe0f",
    name: "Серверная",
    left: "951px",
    top: "450px",
    width: "32px",
    height: "16px",
    roomNumber: "2.9",
    section: "Служебная",
  },

  {
    id: "646fe57b-9e35-48bd-972e-d4461c14bb9d",
    name: "Санузел",
    left: "1002px",
    top: "430px",
    width: "14px",
    height: "20px",
    roomNumber: "2.10",
    section: "Служебная",
  },

  {
    id: "65d2717c-0759-40cd-8fc2-c27b7aeeab99",
    name: "Коридор",
    left: "1015px",
    top: "430px",
    width: "33px",
    height: "20px",
    roomNumber: "2.11",
    section: "Служебная",
  },

  {
    id: "65d2717c-0759-40cd-8fc2-c27b7aeeab99",
    name: "Коридор",
    left: "1047px",
    top: "430px",
    width: "28px",
    height: "85px",
    roomNumber: "2.11",
    section: "Служебная",
  },
  {
    id: "9f8a7f64-36e8-4ffa-8f76-be0d83775c38",
    name: "Пост охраны",
    left: "1058px",
    top: "481px",
    width: "17px",
    height: "7px",
    roomNumber: "2.12",
    zIndex: "10",
    section: "Служебная",
  },

  {
    id: "420fa328-c8b6-4db2-921f-dc903d8cb27e",
    name: "Холодильная камера",
    left: "1092px",
    top: "355px",
    width: "25px",
    height: "22px",
    roomNumber: "2.13",
    section: "Служебная",
  },
  //1ый этаж
  {
    id: "40729af7-db5a-42ee-86d7-b2657840b54b",
    name: "Тамбур",
    left: "465px",
    top: "447px",
    width: "35px",
    height: "50px",
    roomNumber: "1",
    transform: "rotate(12deg)",
    section: "Гостевая",
  },
  {
    id: "23e52001-739b-43cf-a65d-1531d1bc40ed",
    name: "Вестибюль",
    left: "498px",
    top: "462px",
    width: "105px",
    height: "50px",
    roomNumber: "2",
    transform: "rotate(12deg)",
    section: "Гостевая",
  },

  {
    id: "c29c6e3e-ad38-4f8f-98ec-3871fd5f54e2",
    name: "Вестибюль",
    left: "595px",
    top: "470px",
    width: "86px",
    height: "53px",
    roomNumber: "2/1",
    section: "Гостевая",
  },

  {
    id: "a14a3668-cbcc-4da5-b5d6-08bc6e2942bb",
    name: "Фойе",
    left: "680px",
    top: "456px",
    width: "96px",
    height: "67px",
    roomNumber: "3",
    section: "Гостевая",
  },

  {
    id: "87096702-778f-410b-b004-d336d8233091",
    name: "Зона бара",
    left: "775px",
    top: "456px",
    width: "18px",
    height: "67px",
    roomNumber: "4",
    section: "Гостевая",
  },

  {
    id: "680b27cc-f348-410e-90a5-71f517e3976d",
    name: "Зона технологии бара",
    left: "792px",
    top: "471px",
    width: "35px",
    height: "35px",
    roomNumber: "5",
    section: "Служебная",
  },

  {
    id: "46b7589f-e077-4b50-80ab-6195db447ed2",
    name: "Коридор",
    left: "792px",
    top: "506px",
    width: "45px",
    height: "17px",
    roomNumber: "6",
    section: "Служебная",
  },

  {
    id: "46b7589f-e077-4b50-80ab-6195db447ed2",
    name: "Коридор",
    left: "826px",
    top: "232px",
    width: "11px",
    height: "275px",
    roomNumber: "6",
    section: "Служебная",
  },

  {
    id: "9de448f3-58cc-425d-8921-44dae0cf1ab1",
    name: "Комната светорежиссера и видео инженера",
    left: "792px",
    top: "433px",
    width: "26px",
    height: "39px",
    roomNumber: "7",
    section: "Сценографическая",
    clipPath: "polygon(0 10px, 20px 0, 100% 0, 100% 100%, 0 100%)",
  },

  {
    id: "48b012df-ee8d-4b33-8795-060df917b294",
    name: "Комната звукорежиссера",
    left: "698px",
    top: "436px",
    width: "23px",
    height: "21px",
    roomNumber: "7/1",
    section: "Сценографическая",
  },

  {
    id: "725d6818-02a6-4b7b-9723-4f1c5dbbe350",
    name: "Кладовая",
    left: "809px",
    top: "388px",
    width: "18px",
    height: "46px",
    roomNumber: "8",
    section: "Служебная",
  },

  {
    id: "2a96c968-0198-4de5-94b4-261168f80902",
    name: "Кладовая",
    left: "817px",
    top: "433px",
    width: "10px",
    height: "39px",
    roomNumber: "9",
    section: "Служебная",
  },

  {
    id: "f14273c1-5d7c-4b00-ac0c-86367474bbbe",
    name: "Лестница",
    left: "809px",
    top: "340px",
    width: "18px",
    height: "49px",
    roomNumber: "10",
    section: "Служебная",
  },

  {
    id: "c7849b8a-e322-4b36-bd11-3d6842412014",
    name: "Левый карман сцены",
    left: "698px",
    top: "258px",
    width: "23px",
    height: "61px",
    roomNumber: "11",
    section: "Сценографическая",
  },

  {
    id: "2850c9ca-799a-4718-81fa-60d278fc9456",
    name: "Правый карман сцены",
    left: "790px",
    top: "258px",
    width: "37px",
    height: "61px",
    roomNumber: "11/1",
    section: "Сценографическая",
  },
  {
    id: "2850c9ca-799a-4718-81fa-60d278fc9456",
    name: "Кладовая",
    left: "809px",
    top: "318px",
    width: "18px",
    height: "23px",
    roomNumber: "11/2",
    section: "Служебная",
  },

  {
    id: "33e1ff17-4d6a-4fa5-8f0b-edd6931e4059",
    name: "Сцена",
    left: "720px",
    top: "258px",
    width: "71px",
    height: "61px",
    roomNumber: "12",
    section: "Сценографическая",
  },

  {
    id: "2b4ae6fc-afb3-4538-a1ec-3d4550bbb61a",
    name: "Партер зала",
    left: "720px",
    top: "318px",
    width: "73px",
    height: "119px",
    roomNumber: "12/1",
    section: "Сценографическая",
  },

  {
    id: "a04c0c8e-02fe-4af0-9fec-ca2456aa9d9d",
    name: "Правый бенуар",
    left: "792px",
    top: "318px",
    width: "18px",
    height: "126px",
    roomNumber: "14",
    section: "Сценографическая",
    clipPath: " polygon(0px 0, 100% 0%, 100% 90%, 0% 100%, 0% 40px)",
  },

  {
    id: "f126d7fb-1221-4567-a274-1cdb4de40716",
    name: "Правая ложа",
    left: "801px",
    top: "389px",
    width: "18px",
    height: "23px",
    borderRadius: "50%",
    roomNumber: "14/1",
    zIndex: "10",
    section: "Сценографическая",
  },

  {
    id: "3ee8b5c7-a9b5-42cb-b6ef-17438cf10573",
    name: "Левый бенуар",
    left: "698px",
    top: "318px",
    width: "23px",
    height: "119px",
    roomNumber: "15",
    section: "Сценографическая",
  },

  {
    id: "9d0ab99f-767b-4cb4-b4dd-50f3f5a49f4d",
    name: "Левая ложа",
    left: "690px",
    top: "383px",
    width: "18px",
    height: "32px",
    roomNumber: "15/1",
    borderRadius: "0 100% 10% 0",
    zIndex: "10",
    section: "Сценографическая",
  },

  {
    id: "9779bdfc-3587-43fe-bd90-c9d202af6fae",
    name: "Партер зала",
    left: "720px",
    top: "436px",
    width: "73px",
    height: "22px",
    roomNumber: "16",
    section: "Сценографическая",
  },

  {
    id: "55d34ce5-8dd9-410f-ba15-eea08116ae37",
    name: "Кабинет",
    left: "644px",
    top: "443px",
    width: "16px",
    height: "18px",
    roomNumber: "17",
    section: "Гостевая",
  },
  {
    id: "bd4fafa1-2e87-45ad-acf0-eef39d46ad12",
    name: "Тамбур",
    left: "644px",
    top: "460px",
    width: "37px",
    height: "11px",
    roomNumber: "17/1",
    section: "Гостевая",
  },
  {
    id: "9eb7867f-b51c-4559-886a-99606a6f73b3",
    name: "Кабинет",
    left: "659px",
    top: "443px",
    width: "22px",
    height: "18px",
    roomNumber: "18",
    section: "Гостевая",
  },
  {
    id: "a374a236-6e33-4b0e-90b5-44c79b0c675f",
    name: "Комната охраны",
    left: "644px",
    top: "419px",
    width: "36px",
    height: "25px",
    roomNumber: "19",
    section: "Служебная",
  },
  {
    id: "082e483d-4023-44cc-9c81-821e6ca41338",
    name: "Коридор",
    left: "610px",
    top: "419px",
    width: "26px",
    height: "52px",
    roomNumber: "20",
    section: "Гостевая",
  },
  {
    id: "666486e2-a728-4b85-9709-283220fcc628",
    name: "Санузел",
    left: "635px",
    top: "419px",
    width: "10px",
    height: "52px",
    roomNumber: "21",
    section: "Гостевая",
  },
  {
    id: "673df938-ef9e-452e-84c6-80f3e9be27e3",
    name: "Санузел",
    left: "578px",
    top: "419px",
    width: "33px",
    height: "52px",
    roomNumber: "22",
    section: "Гостевая",
  },
  {
    id: "81920576-26f9-4c8e-b028-f0b962bd6588",
    name: "Санузел",
    left: "548px",
    top: "419px",
    width: "31px",
    height: "40px",
    roomNumber: "23",
    section: "Гостевая",
    clipPath: " polygon(0px 0, 100% 0%, 100% 100%, 0% 80%)",
  },
  {
    id: "bd09eea7-d861-4cdb-befb-26546b9d7c1b",
    name: "Кладовая",
    left: "532px",
    top: "419px",
    width: "17px",
    height: "31px",
    roomNumber: "24",
    section: "Служебная",
    clipPath: " polygon(10px 0, 100% 0%, 100% 100%, 10% 100%)",
  },
  {
    id: "3872b72c-d164-441f-963e-3c9ec5362385",
    name: "Коридор",
    left: "525px",
    top: "419px",
    width: "12px",
    height: "39px",
    roomNumber: "25",
    section: "Служебная",
    transform: "rotate(8deg)",
  },
  {
    id: "3872b72c-d164-441f-963e-3c9ec5362385",
    name: "Коридор",
    left: "534px",
    top: "452px",
    width: "46px",
    height: "12px",
    roomNumber: "25",
    section: "Служебная",
    transform: "rotate(12deg)",
  },
  {
    id: "8d1cb208-4ebf-497d-9cd3-b05dc462632c",
    name: "Коридор",
    left: "485px",
    top: "295px",
    width: "14px",
    height: "113px",
    roomNumber: "26",
    section: "Служебная",
    transform: "rotate(8deg)",
  },

  {
    id: "e9c8b513-ec90-4195-8e94-0f8d66288855",
    name: "Инженерная комната",
    left: "502px",
    top: "414px",
    width: "25px",
    height: "32px",
    roomNumber: "27",
    transform: "rotate(12deg)",
    zIndex: "10",
    section: "Служебная",
  },
  {
    id: "200c9eda-ee76-4fa3-b41e-6105cea1c20b",
    name: "Инженерная комната",
    left: "475px",
    top: "411px",
    width: "52px",
    height: "40px",
    roomNumber: "28",
    transform: "rotate(13deg)",
    section: "Служебная",
  },
  {
    id: "5b45e450-502f-4836-b1ef-fd9947e0b23b",
    name: "Санузел",
    left: "539px",
    top: "410px",
    width: "18px",
    height: "10px",
    roomNumber: "29",
    section: "Служебная",
  },
  {
    id: "9ab35c83-9ba2-4209-b0c4-2fbd8bae2f16",
    name: "Грим-уборная",
    left: "535px",
    top: "384px",
    width: "22px",
    height: "27px",
    roomNumber: "30",
    section: "Служебная",
    clipPath: " polygon(10px 0, 100% 0%, 100% 100%, 11% 100%)",
  },
  {
    id: "59d19aa1-095e-4cf3-b27b-e6ba20b1c4f0",
    name: "Комната отдыха",
    left: "556px",
    top: "384px",
    width: "21px",
    height: "36px",
    roomNumber: "31",
    section: "Служебная",
  },
  {
    id: "30851853-3d9c-4475-9cc7-3ccdb9a4ff6d",
    name: "Грим-уборная",
    left: "576px",
    top: "395px",
    width: "24px",
    height: "14px",
    roomNumber: "32",
    section: "Служебная",
  },
  {
    id: "84bb9d7d-671c-411c-9b6e-8fa7fcd99e1a",
    name: "Санузел",
    left: "576px",
    top: "408px",
    width: "24px",
    height: "12px",
    roomNumber: "33",
    section: "Служебная",
  },
  {
    id: "a0735884-5660-44c9-9e53-96c2ad603b89",
    name: "Чайная комната",
    left: "599px",
    top: "384px",
    width: "82px",
    height: "36px",
    roomNumber: "34",
    section: "Гостевая",
  },
  {
    id: "3e627079-56f9-435f-9579-da6562a7c562",
    name: "Электрощитовая",
    left: "656px",
    top: "400px",
    width: "25px",
    height: "20px",
    roomNumber: "35",
    zIndex: "10",
    section: "Служебная",
  },
  {
    id: "30ed00ef-9dee-4a5a-b259-a1d8e12bd935",
    name: "Коридор",
    left: "540px",
    top: "355px",
    width: "141px",
    height: "30px",
    roomNumber: "36",
    section: "Служебная",
    clipPath: " polygon(10px 0, 100% 0%, 100% 100%, 2% 100%)",
  },
  {
    id: "5ee15df5-281a-4ee4-ae1f-826eb338f5fc",
    name: "Тамбур",
    left: "576px",
    top: "384px",
    width: "24px",
    height: "12px",
    roomNumber: "36/1",
    section: "Служебная",
  },

  {
    id: "6c5c7683-f9b4-46ec-8402-a18b8c017c92",
    name: "Коридор",
    left: "680px",
    top: "217px",
    width: "19px",
    height: "240px",
    roomNumber: "37",
    section: "Служебная",
  },

  {
    id: "6c5c7683-f9b4-46ec-8402-a18b8c017c92",
    name: "Коридор",
    left: "698px",
    top: "217px",
    width: "82px",
    height: "26px",
    roomNumber: "37",
    section: "Служебная",
  },
  {
    id: "2daeb948-6bda-41e0-881f-e22c624a468c",
    name: "Коридор",
    left: "698px",
    top: "242px",
    width: "82px",
    height: "17px",
    roomNumber: "37/1",
    section: "Сценографическая",
  },
  {
    id: "0375d6ba-00f4-4b5f-ab00-6cfb3c9fde1a",
    name: "Костюмерная",
    left: "639px",
    top: "318px",
    width: "42px",
    height: "38px",
    roomNumber: "38",
    section: "Служебная",
  },
  {
    id: "3ab9ce24-9dc4-43aa-8018-e812e277b7fb",
    name: "Костюмерная",
    left: "602px",
    top: "325px",
    width: "38px",
    height: "31px",
    roomNumber: "39",
    section: "Служебная",
  },
  {
    id: "f98f7af6-2ab4-4518-8664-c4325535d7af",
    name: "Грим-уборные",
    left: "545px",
    top: "297px",
    width: "58px",
    height: "59px",
    roomNumber: "40",
    section: "Служебная",
    clipPath: " polygon(12px 0, 100% 0%, 100% 100%, 0% 100%)",
  },

  {
    id: "c72c644a-4c1d-417b-9669-e28a27019915",
    name: "Санузел",
    left: "602px",
    top: "297px",
    width: "21px",
    height: "29px",
    roomNumber: "41/1",
    section: "Служебная",
  },
  {
    id: "96aa4d4c-7506-4b8b-98be-63ea3ea06aed",
    name: "Душевая",
    left: "622px",
    top: "297px",
    width: "18px",
    height: "29px",
    roomNumber: "41/2",
    section: "Служебная",
  },
  {
    id: "2312f891-b44f-4ac9-b589-fae2da5661a7",
    name: "Кладовая",
    left: "639px",
    top: "297px",
    width: "24px",
    height: "22px",
    roomNumber: "42",
    section: "Служебная",
  },
  {
    id: "5f201162-02c1-4366-9dd5-76680a05f113",
    name: "Служебное помещение",
    left: "662px",
    top: "297px",
    width: "19px",
    height: "22px",
    roomNumber: "42м",
    section: "Служебная",
  },
  {
    id: "415360bf-b380-4e5e-823c-b9be92d03a7b",
    name: "Коридор",
    left: "492px",
    top: "288px",
    width: "189px",
    height: "10px",
    roomNumber: "43",
    section: "Служебная",
  },
  {
    id: "415360bf-b380-4e5e-823c-b9be92d03a7b",
    name: "Коридор",
    left: "538px",
    top: "295px",
    width: "10px",
    height: "125px",
    roomNumber: "43",
    transform: "rotate(8deg)",
    section: "Служебная",
  },
  {
    id: "81d9e53f-0fbe-49f9-8064-a4884f1cc2ed",
    name: "Кабинет",
    left: "642px",
    top: "257px",
    width: "19px",
    height: "31px",
    roomNumber: "44/1",
    section: "Служебная",
  },
  {
    id: "9a3a739a-2d0f-4e2b-82cf-7d87a74cb260",
    name: "Кабинет врача",
    left: "660px",
    top: "257px",
    width: "21px",
    height: "31px",
    roomNumber: "44/2",
    section: "Служебная",
  },
  {
    id: "a089fa89-f57c-4f1a-ae69-2b6fe2a7baf1",
    name: "Кабинет",
    left: "622px",
    top: "248px",
    width: "21px",
    height: "41px",
    roomNumber: "45",
    section: "Служебная",
  },
  {
    id: "cc79c619-10c8-4ecb-b37d-99a85a6e7c87",
    name: "Кабинет",
    left: "582px",
    top: "248px",
    width: "41px",
    height: "41px",
    roomNumber: "46",
    section: "Служебная",
  },
  {
    id: "501d740d-82ad-4eb5-b144-cda0dedc5181",
    name: "Кабинет",
    left: "565px",
    top: "248px",
    width: "18px",
    height: "41px",
    roomNumber: "47",
    section: "Служебная",
  },
  {
    id: "97c758a3-6591-4f47-afa5-5b33f0d624f7",
    name: "Приемная",
    left: "538px",
    top: "248px",
    width: "28px",
    height: "41px",
    roomNumber: "48",
    section: "Служебная",
  },
  {
    id: "14043cb3-d499-436d-9af0-a11323c32a6c",
    name: "Санузел",
    left: "538px",
    top: "217px",
    width: "12px",
    height: "32px",
    roomNumber: "49",
    section: "Служебная",
  },
  {
    id: "602ba6b9-ab5b-42c8-b56c-55e469742ccf",
    name: "Кабинет",
    left: "549px",
    top: "217px",
    width: "48px",
    height: "32px",
    roomNumber: "50",
    section: "Служебная",
  },
  {
    id: "daaac814-d605-4eae-beaf-aba6c285e558",
    name: "Кабинет",
    left: "596px",
    top: "217px",
    width: "27px",
    height: "32px",
    roomNumber: "51",
    section: "Служебная",
  },
  {
    id: "Инженерная комната",
    name: "Кабинет",
    left: "622px",
    top: "217px",
    width: "21px",
    height: "32px",
    roomNumber: "52",
    section: "Служебная",
  },
  {
    id: "c54e3bd6-c90a-491b-83e5-550ebc5f9d2b",
    name: "Кладовая",
    left: "642px",
    top: "217px",
    width: "39px",
    height: "41px",
    roomNumber: "53",
    section: "Служебная",
  },
  {
    id: "ff011e19-2abd-499c-9737-2a7768d350d0",
    name: "Кабинет",
    left: "679px",
    top: "165px",
    width: "15px",
    height: "53px",
    roomNumber: "54",
    section: "Служебная",
  },
  {
    id: "ff011e19-2abd-499c-9737-2a7768d350d0",
    name: "Кабинет",
    left: "716px",
    top: "182px",
    width: "15px",
    height: "36px",
    roomNumber: "55",
    section: "Служебная",
  },
  {
    id: "5cfe34b3-6d7b-4060-83fa-66ba25efa0ee",
    name: "Помещение приема пищи",
    left: "730px",
    top: "182px",
    width: "28px",
    height: "36px",
    roomNumber: "55/1",
    section: "Служебная",
  },
  {
    id: "1d02cb89-3da9-4ade-8628-c7a8738fe68d",
    name: "Санузел",
    left: "757px",
    top: "188px",
    width: "23px",
    height: "30px",
    roomNumber: "56",
    section: "Служебная",
  },
  {
    id: "5bac18b9-5cfb-46b8-8a40-00c2096bbe1f",
    name: "Санузел",
    left: "779px",
    top: "188px",
    width: "34px",
    height: "33px",
    roomNumber: "57",
    section: "Служебная",
    clipPath: " polygon(0% 0, 100% 22%, 100% 100%, 0% 100%)",
  },
  {
    id: "46dd4eb2-dfc2-4a1c-b799-3e85ac733baa",
    name: "Техническое помещение",
    left: "812px",
    top: "180px",
    width: "47px",
    height: "22px",
    roomNumber: "58",
    section: "Служебная",
    clipPath: " polygon(0% 0, 100% 35%, 100% 100%, 0% 100%)",
  },
  {
    id: "46dd4eb2-dfc2-4a1c-b799-3e85ac733baa",
    name: "Техническое помещение",
    left: "779px",
    top: "172px",
    width: "34px",
    height: "25px",
    roomNumber: "58/1",
    clipPath: " polygon(0% 0, 100% 0%, 100% 100%, 0% 70%)",
    section: "Служебная",
  },
  {
    id: "46dd4eb2-dfc2-4a1c-b799-3e85ac733baa",
    name: "Техническое помещение",
    left: "716px",
    top: "165px",
    width: "42px",
    height: "18px",
    roomNumber: "58/1",
    section: "Служебная",
  },
  {
    id: "46dd4eb2-dfc2-4a1c-b799-3e85ac733baa",
    name: "Техническое помещение",
    left: "757px",
    top: "165px",
    width: "23px",
    height: "24px",
    roomNumber: "58/1",
    section: "Служебная",
  },
  {
    id: "3ba4d7f1-c22d-494d-aede-947a1a06bae7",
    name: "Тамбур",
    left: "812px",
    top: "201px",
    width: "19px",
    height: "20px",
    roomNumber: "59",
    section: "Служебная",
  },

  {
    id: "650dc353-3867-4b57-9bc8-7e3fada324da",
    name: "Коридор",
    left: "779px",
    top: "220px",
    width: "80px",
    height: "13px",
    roomNumber: "60",
    section: "Служебная",
  },
  {
    id: "650dc353-3867-4b57-9bc8-7e3fada324da",
    name: "Коридор",
    left: "836px",
    top: "236px",
    width: "188px",
    height: "19px",
    roomNumber: "60",
    section: "Служебная",
  },
  {
    id: "d6c021bf-d605-460f-b2f2-8af1698cd6da",
    name: "Тамбур",
    left: "989px",
    top: "254px",
    width: "45px",
    height: "10px",
    roomNumber: "61",
    section: "Служебная",
  },
  {
    id: "506e42b5-1a2c-4932-ab55-37d23bc2027b",
    name: "Бытовое помещение",
    left: "989px",
    top: "263px",
    width: "17px",
    height: "31px",
    roomNumber: "61/1",
    section: "Служебная",
  },
  {
    id: "8f644e73-36cf-4586-9b4b-31cd9b7704c3",
    name: "Бытовое помещение",
    left: "1005px",
    top: "263px",
    width: "29px",
    height: "31px",
    roomNumber: "61/2",

    section: "Служебная",
  },

  {
    id: "5eb15d58-479a-4404-aaad-db2c433bd40d",
    name: "Кладовая",
    left: "889px",
    top: "480px",
    width: "36px",
    height: "34px",
    roomNumber: "62",
    section: "Служебная",
  },

  {
    id: "5eb15d58-479a-4404-aaad-db2c433bd40d",
    name: "Кладовая",
    left: "912px",
    top: "420px",
    width: "13px",
    height: "61px",
    roomNumber: "62",
    section: "Служебная",
  },

  {
    id: "c1108216-2524-4901-932c-4f14015c018b",
    name: "Тамбур",
    left: "912px",
    top: "345px",
    width: "13px",
    height: "76px",
    roomNumber: "63",
    section: "Служебная",
  },
  {
    id: "d3c16283-b825-489b-be15-634287634cf9",
    name: "Электрощитовая",
    left: "897px",
    top: "325px",
    width: "28px",
    height: "21px",
    roomNumber: "63/1",
    clipPath: " polygon(0px 0, 100% 0%, 100% 80%, 100% 100%, 40% 100%)",
    section: "Служебная",
  },

  {
    id: "4decd71b-adfd-4e48-a7aa-6f02d9e5f341",
    name: "Кладовая",
    left: "779px",
    top: "232px",
    width: "47px",
    height: "27px",
    roomNumber: "64",
    section: "Служебная",
  },
  {
    id: "7ca9d3ff-4b8c-45b2-90e0-e027806a4242",
    name: "Репетиционный зал",
    left: "495px",
    top: "335px",
    width: "42px",
    height: "80px",
    roomNumber: "65",
    transform: "rotate(8deg)",
    section: "Служебная",
  },
  {
    id: "3bd38c33-302d-47f0-bcde-05b869877eb8",
    name: "Грим-уборная",
    left: "501px",
    top: "295px",
    width: "43px",
    height: "42px",
    roomNumber: "66",
    transform: "rotate(6deg)",
    section: "Служебная",
  },
  {
    id: "37f73cb2-4385-4909-9b4e-ee46cfc47116",
    name: "Санузел",
    left: "518px",
    top: "320px",
    width: "9px",
    height: "17px",
    roomNumber: "66/1",
    transform: "rotate(6deg)",
    section: "Служебная",
  },
  {
    id: "f90146a9-5752-4630-a3cf-ded80e09367f",
    name: "Душевая",
    left: "526px",
    top: "321px",
    width: "16px",
    height: "17px",
    roomNumber: "66/2",
    transform: "rotate(6deg)",
    section: "Служебная",
  },
  {
    id: "b439ded7-8cc3-43a7-a080-125f0511ec25",
    name: "Санузел",
    left: "830px",
    top: "201px",
    width: "29px",
    height: "20px",
    roomNumber: "67",
    section: "Служебная",
  },

  {
    id: "dbc81d46-8197-46db-b69c-78c73e271fd6",
    name: "Лестница",
    left: "835px",
    top: "258px",
    width: "57px",
    height: "20px",
    roomNumber: "68",
    section: "Служебная",
  },

  {
    id: "dbc81d46-8197-46db-b69c-78c73e271fd6",
    name: "Лестница",
    left: "877px",
    top: "277px",
    width: "15px",
    height: "31px",
    roomNumber: "68",
    section: "Служебная",
  },
];

// Вспомогательная функция для поиска комнаты по ID
export const findRoomById = (id: string): Room | undefined => {
  return ROOMS_THEATER.find((room) => room.id === id);
};

// Вспомогательная функция для поиска комнаты по номеру
export const findRoomByNumber = (number: string): Room | undefined => {
  return ROOMS_THEATER.find((room) => room.roomNumber === number);
};
